import { Lightning, Utils } from '@lightningjs/sdk';
import { Column } from '@lightningjs/ui-components';
import EpisodesComponent from './components/EpisodesComponent';
import EpisodesInfo from './components/EpisodesInfo';

export default class Episodes extends Lightning.Component {
  static _template() {
    return {
      LogoIcon: {
        w: 606,
        h: 274,
        Shadow: {
          y: 806,
          x: 1314,
          rect: true,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo-shadow.png'), 606, 274),
          zIndex: 99,
        },
        Logo: {
          y: 978,
          x: 1555,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo.png'), 341, 53),
          zIndex: 100,
        },
      },
      Content: {
        x: 120,
        w: 1720,
        type: EpisodesInfo,
      },
      Column: {
        lazyUpCount: 2,
        lazyUpCountBuffer: 2,
        type: Column,
        plinko: true,
        collision: true,
        scrollIndex: 2,
        x: 845,
        y: 105,
      },
      Season: {
        x: 116,
        y: 520,
        type: Column,
        plinko: true,
        collision: true,
      },
    };
  }

  get _Column() {
    return this.tag('Column');
  }
  get _Season() {
    return this.tag('Season');
  }

  set episodes(val) {
    this._episodes = val;
  }

  $changeEpisodes({ seriesId, seasonId }) {
    const series = this._episodes;
    const items = [];

    series?.data
      ?.find((season) => season.id === seasonId)
      ?.movies.forEach((movie, index) => {
        // Create an instance of EpisodesComponent for each movie
        const episodeComponent = {
          w: 430,
          h: 220,
          index,
          collision: true,
          type: EpisodesComponent,
          movieInfo: series,
          episodes: movie,
          src: movie['screenshot.expiring_url'],
        };

        // Push the episodeComponent to the items array
        items.push(episodeComponent);
      });

    this.tag('Column').items = items;
    this._Column.lazyUpCount = 2;
    this._Column.lazyUpCountBuffer = 2;
  }

  _firstActive() {
    this._setState('Season');
  }

  $setState(state) {
    this._setState(state);
  }

  $setIndex(index) {
    this._Column.scrollTo(index, 10);
  }

  $setSeasonIndex(index) {
    this._Season.selectedIndex = index;
  }

  $scroll(event) {
    this._handleScroll(event);
  }

  _handleScroll(event) {
    let currentIndex = this._Column.selectedIndex;
    let nextIndex = currentIndex + 1;
    let previousIndex = currentIndex - 1;
    if (event.deltaY > 0) {
      this._Column.scrollTo(nextIndex, 50);
    } else if (event.deltaY < 0) {
      this._Column.scrollTo(previousIndex, 50);
    }
  }

  static _states() {
    return [
      class Column extends this {
        _getFocused() {
          return this._Column;
        }

        _handleLeft() {
          this._setState('Season');
        }
      },
      class Season extends this {
        _getFocused() {
          return this.tag('Season');
        }
        _handleRight() {
          this._setState('Column');
        }
      },
    ];
  }

  $changeSeriesInfo({
    title,
    description,
    category,
    duration,
    cover,
    rating,
    votes,
    contentRating,
  }) {
    const ratingText = `${rating}/10`;
    const categoryText = category.join(' • ');

    const parts = duration.split(':').map((part) => parseInt(part));
    let seconds = 0;
    if (parts.length === 3) {
      // If time format is HH:MM:SS
      seconds = parts[0] * 3600 + parts[1] * 60 + parts[2];
    } else if (parts.length === 2) {
      // If time format is MM:SS
      seconds = parts[0] * 60 + parts[1];
    }
    // Modify the duration text
    let hours = parts.length === 3 ? parts[0].toString().padStart(2, '0') : '00';
    let minutes = parts[parts.length - 2].toString().padStart(2, '0');
    let secondsPart = parts[parts.length - 1].toString().padStart(2, '0');

    const durationText =
      seconds >= 3600 ? `${hours}:${minutes}:${secondsPart} | ` : `${minutes}:${secondsPart} | `;

    this.tag('Content.Info').patch({
      Title: { text: { text: title } },
      Informations: {
        DurationAndIcon: {
          Svg: {
            x: seconds > 3600 ? 130 : 90,
            texture: lng.Tools.getSvgTexture(
              Utils.asset('images/movie-info-icons/star.svg'),
              20,
              20
            ),
          },
          text: { text: durationText },
        },
        Rating: {
          x: seconds > 3600 ? 165 : 125,
          text: { text: `IMDB ${ratingText}` },
        },
        Votes: {
          x: seconds > 3600 ? 315 : 275,
          text: { text: `(${votes})` },
        },
        ContentRating: {
          x: seconds > 3600 ? 375 : 330,
          text: { text: `| (${contentRating})` },
        },
      },
      Category: {
        text: { text: categoryText },
      },
      Description: { text: { text: description } },
    });

    this.tag('Content.Cover').patch({
      texture: { src: cover },
    });
  }
}
